import find from 'lodash/find';

export default function findRegionById(regions, regionId) {
  return find(regions, { id: regionId });
}
